import React from 'react';
import { BaseModal } from './BaseModal';

interface PrivacyPolicyInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function PrivacyPolicyInfoModal({ isOpen, onClose }: PrivacyPolicyInfoModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="OneTrust Privacy Policy Integration"
    >
      <div className="space-y-6 text-gray-600 dark:text-gray-300">
        <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Dynamic Privacy Policy Management
          </h3>
          <p className="mb-4">
            This privacy policy is powered by OneTrust's Privacy Notice Management solution. Instead of maintaining a static 
            privacy policy document, we use OneTrust's dynamic system that allows for:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Real-time policy updates without code changes</li>
            <li>Automated version control and change tracking</li>
            <li>Multi-language support with automatic translations</li>
            <li>Compliance with global privacy regulations</li>
          </ul>
        </div>

        <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            How It Works
          </h3>
          <p className="mb-4">
            The privacy policy content is managed entirely within OneTrust's platform. When changes are made and published:
          </p>
          <ol className="list-decimal list-inside space-y-2 ml-4">
            <li>Updates are instantly reflected on the website</li>
            <li>All changes are automatically versioned and archived</li>
            <li>Compliance teams can review and approve changes</li>
            <li>Users always see the most current version</li>
          </ol>
        </div>

        <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Technical Implementation
          </h3>
          <p className="mb-4">
            A single script tag connects your website to OneTrust's Privacy Notice API. This script:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Automatically loads the latest policy version</li>
            <li>Handles all formatting and styling</li>
            <li>Manages language preferences</li>
            <li>Tracks policy acknowledgments</li>
          </ul>
        </div>

        <div className="mt-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg">
          <p className="text-sm text-blue-800 dark:text-blue-200">
            This integration ensures our privacy policy stays current and compliant while providing a seamless experience 
            for our users. All updates are managed through OneTrust's platform, requiring no changes to the website code.
          </p>
        </div>
      </div>
    </BaseModal>
  );
}